import { RouteObject } from 'react-router-dom';
import Authorizations from '../Authorizations';
import { ViewAuthorization } from '../pages';

const AuthorizationsRoutes: RouteObject[] = [
  {
    path: 'authorizations',
    element: <Authorizations />,
  },
  {
    path: 'authorizations/:id',
    element: <ViewAuthorization />,
  },
];

export default AuthorizationsRoutes;
